import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Checkbox from '@material-ui/core/Checkbox';

export default function EnhancedTableHead (props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
      {props.multiDelete ? (<TableCell 
          style={{minWidth:'50px', maxWidth:'50px', width:'50px'}}>
          <label className="m-0" for="select all desserts">
            <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "Select All Notes " ,"title":"Select All Notes"}}
          />
          <span className='hide-elm'>Select All Notes</span>
          </label> 
      </TableCell>) : null}
        {props.headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding='default'
            sortDirection={orderBy === headCell.id ? order : false}
            style={{minWidth:headCell.width, maxWidth:headCell.width, width:headCell.width, fontSize:headCell.fontSize}}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={order === 'desc' ? 'desc':'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <span className="th-header"> {headCell.label} </span>
              {orderBy === headCell.id ? (
                <span className="hide-elm">
                  {/* {order === 'desc' ? '' : ''} */}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};
